import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Formik } from "formik";
import {
  Autocomplete,
  createTheme,
  Divider,
  FormHelperText,
  Grid2,
  IconButton,
  TextField,
  ThemeProvider,
  Typography,
  useTheme,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
} from "@mui/material";
import * as Yup from "yup";
import { useState } from "react";
import {
  useGetPackagesQuery,
  useLazyGetPackagesQuery,
} from "store/slices/apis/packageSlice";
import { useGetContractorQuery } from "store/slices/apis/contractors";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { IoMdClose } from "react-icons/io";
import DragAndDropUpload from "components/FileUploader/DragAndDropUpload";
import { FaRegFileLines } from "react-icons/fa6";
import { RxCross2 } from "react-icons/rx";
import { useEditKeyClearanceMutation } from "store/slices/apis/keyClearanceSlice";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {ReactComponent as CrossIcon } from "assets/PwC_Funct_Icons_Close_Outline_Black_RGB.svg"
import { ReactComponent as CalendarIcon } from "assets/PwC_Funct_Icons_Calendar_Outline_Black_RGB.svg"

const Statuses = [
  { label: "Yet to be applied", value: "Yet to be applied" },
  { label: "Applied", value: "Applied" },
  { label: "Closed", value: "Closed" },
];

const numbers = Array.from({ length: 100 }, (_, i) => i + 1);

const escalationRequired = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" },
];

export default function EditClearance(props) {
  const {
    open,
    cancelIssue,
    openNotification,
    data,
    isViewIssueModal,
    refetch,
  } = props;
  const newtheme = useTheme();
  const { projectId } = useParams();
  const [files, setFiles] = useState([]);
  const [dense, setDense] = useState(false);
  const [secondary, setSecondary] = useState(false);
  const { data: packages } = useGetPackagesQuery({ projectId: projectId });
  const { data: contractors } = useGetContractorQuery();
  const [getSubPackage1, { data: subPackageList1 }] = useLazyGetPackagesQuery();
  const [getSubPackage2, { data: subPackageList2 }] = useLazyGetPackagesQuery();

  const [editKeyClearance, { isLoading }] = useEditKeyClearanceMutation();

  const [formData, setFormData] = useState({
    // status_as_on: data?.status_as_on,
    project: data?.project,
    approval_compliance_description: data?.approval_compliance_description,
    compliance_owner: data?.compliance_owner,
    content_owner: data?.content_owner,
    approving_authority_agency: data?.approving_authority_agency,
    plan_date: data?.plan_date,
    revised_plan_date: data?.revised_plan_date,
    actual_expected_date: data?.actual_expected_date,
    escalation_required: data?.escalation_required,
    status: data?.status,
    tat: data?.tat,
    // current_status: data?.current_status,
  });

  useEffect(() => {
    getSubPackage1({ projectId: projectId, type: "subPackage1" });
    getSubPackage2({ projectId: projectId, type: "subPackage2" });
  }, [open]);

  const theme = createTheme({
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            border: "2px solid #e6e6e6",
            "& .MuiFilledInput-input": {
              backgroundColor: "#fff",
              color: "#252525",
              fontSize: "16px",
            },
            "& .MuiFilledInput-root::before": {
              borderBottom: "none",
            },
            "& .MuiFilledInput-root::after": {
              borderBottom: `2px solid ${newtheme?.customSettings?.themeColor}`,
            },
            "& .MuiInputLabel-root.Mui-focused": {
              color: "#696969",
              fontSize: "14px",
            },
            "& .MuiFormLabel-root": {
              fontSize: "15px",
            },
            "& .MuiFilledInput-root.Mui-disabled:before": {
              borderBottom: "none",
            },
            "& .MuiFilledInput-root": {
              backgroundColor: "#fff",
            },
            "& .MuiFilledInput-input": {
              backgroundColor: "none",
              fontSize: "14px",
            },
            "& .MuiInputLabel-root.Mui-disabled": {
              color: "#696969",
            },
            "& .MuiFilledInput-root.Mui-disabled": {
              backgroundColor: "#fff",
              color: "inherit",
            },
            "& .MuiFilledInput-input.Mui-disabled": {
              WebkitTextFillColor: "#696969",
              opacity: "none",
            },
          },
        },
      },
    },
  });

  const handleClose = () => { };

  const validationSchema = Yup.object({
    // status_as_on: Yup.string().required("Status As On is required"),
    // project: Yup.string().required("Project is required"),
    approval_compliance_description: Yup.string().required(
      "Approval Compliance Description is required"
    ),
    compliance_owner: Yup.string().required("Compliance Owner is required"),
    content_owner: Yup.string().required("Content Owner is required"),
    approving_authority_agency: Yup.string().required(
      "Approving Authority Agency is required"
    ),
    plan_date: Yup.date()
      .required("Plan Date is required")
      .nullable()
      .typeError("Plan Date must be a valid date"),
    revised_plan_date: Yup.date()
      .required("Revised Plan Date is required")
      .nullable()
      .typeError("Revised Plan Date must be a valid date"),
    escalation_required: Yup.string().required(
      "Escalation Required is required"
    ),
    status: Yup.string().required("Status is required"),
    tat: Yup.number().required("TAT is required")
    // current_status: Yup.string().required("Current Status is required"),
  });

  const handleDrop = (acceptedFiles, rejectedFiles) => {
    if (rejectedFiles.length > 0) {
      openNotification("File type must be image/*");
      return;
    }
    const newFiles = acceptedFiles.filter(
      (file) => !files.some((f) => f.name === file.name)
    );

    if (newFiles.length > 0) {
      setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    }
  };

  const handleRemoveFile = (fileName) => {
    setFiles(files.filter((file) => file.name !== fileName));
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    let reqBody = {
      clearance_number: data?.clearance_number,
      project: values.project,
      approval_compliance_description: values.approval_compliance_description,
      compliance_owner: values.compliance_owner,
      content_owner: values.content_owner,
      approving_authority_agency: values.approving_authority_agency,
      plan_date:
        values?.plan_date && dayjs(values.plan_date).isValid()
          ? dayjs(values.plan_date).format("YYYY-MM-DD") + "T00:00:00.000Z"
          : null,
      revised_plan_date:
        values?.revised_plan_date && dayjs(values.revised_plan_date).isValid()
          ? dayjs(values.revised_plan_date).format("YYYY-MM-DD") + "T00:00:00.000Z"
          : null,
      actual_expected_date:
        values?.actual_expected_date &&
          dayjs(values.actual_expected_date).isValid()
          ? dayjs(values.actual_expected_date).format("YYYY-MM-DD") +
          "T00:00:00.000Z"
          : null,
      escalation_required: values.escalation_required === "Yes" ? true : false,
      status: values.status,
      ProjectId: projectId,
      clearance_id: data?.clearance_id,
      tat: typeof values.tat === 'number' ? values.tat : null,
      workflowApprovalId: data?.workflowApprovalId,
    };
    

    try {
      const formData = new FormData();
      formData.append("clearanceJson", JSON.stringify({ ...reqBody }));
      formData.append("file", files);
      const response = await editKeyClearance({
        id: data?.clearance_id,
        body: formData,
      }).unwrap();
      if (response?.status == "Success") {
        openNotification(
          response?.message || "Clearance updated successfully",
          "success"
        );
        resetForm();
        refetch();
        cancelIssue();
      } else {
        openNotification(response?.message);
      }
    } catch (error) {
      console.log("errr", error);

      openNotification(error?.data?.message, "error");
    } finally {
      setSubmitting(false);
    }
  };

const CustomCalendarIcon = (props) => (
    <CalendarIcon {...props} style={{ width: 26, height: 26, fill:"#696969 ", stroke:"#696969", strokeWidth:4 }} />
  );

  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={open}
        onClose={handleClose}
        sx={{
          "& .MuiDialog-paper": {
            overflowY: "inherit",
          },
        }}
      >
        <DialogTitle sx={{ fontSize: "20px", color: "#696969" }}>
          {isViewIssueModal ? "View" : "Edit"} Clearance
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={cancelIssue}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          {/* <IoMdClose style={{ fontSize: "20px" }} /> */}
         <CrossIcon style={{ fontSize: "20px", width:"20px", height:"20px", fill:"#808080" }} />
        </IconButton>
        <Divider sx={{ w: 1 }} />
        <DialogContent>
          <ThemeProvider theme={theme}>
            <Box sx={{ mt: 1 }}>
              <Formik
                initialValues={formData}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  setFieldValue,
                  setTouched,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Typography
                          variant="h4"
                          gutterBottom
                          sx={{ fontSize: "20px", color: "#252525" }}
                        >
                          {isViewIssueModal
                            ? "Clearance Details"
                            : "Enter Clearance Details"}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          label="Approval Compliance Description"
                          name="approval_compliance_description"
                          fullWidth
                          value={values?.approval_compliance_description}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({
                              ...touched,
                              approval_compliance_description: true,
                            })
                          }
                          variant="filled"
                          disabled={isViewIssueModal}
                        />
                        {touched?.approval_compliance_description &&
                          errors?.approval_compliance_description && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.approval_compliance_description}`}</FormHelperText>
                          )}
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          label="Compliance Owner"
                          name="compliance_owner"
                          fullWidth
                          value={values?.compliance_owner}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({ ...touched, compliance_owner: true })
                          }
                          variant="filled"
                          disabled={isViewIssueModal}
                        />
                        {touched?.compliance_owner &&
                          errors?.compliance_owner && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.compliance_owner}`}</FormHelperText>
                          )}
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          label="Content Owner"
                          name="content_owner"
                          fullWidth
                          value={values?.content_owner}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({ ...touched, content_owner: true })
                          }
                          variant="filled"
                          disabled={isViewIssueModal}
                        />
                        {touched?.content_owner && errors?.content_owner && (
                          <FormHelperText
                            sx={{ color: "#C52A1A", fontSize: "12px" }}
                          >{`${errors?.content_owner}`}</FormHelperText>
                        )}
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          label="Approving Authority Agency"
                          name="approving_authority_agency"
                          fullWidth
                          value={values?.approving_authority_agency}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({
                              ...touched,
                              approving_authority_agency: true,
                            })
                          }
                          variant="filled"
                          disabled={isViewIssueModal}
                        />
                        {touched?.approving_authority_agency &&
                          errors?.approving_authority_agency && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.approving_authority_agency}`}</FormHelperText>
                          )}
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="Plan Date"
                            disabled={isViewIssueModal}
                            value={
                              values?.plan_date ? dayjs(values.plan_date) : null
                            }
                            format="DD-MM-YYYY"
                            onChange={(newValue) => {
                              handleChange({
                                target: {
                                  name: "plan_date",
                                  value: newValue ? newValue : "",
                                },
                              });
                            }}
                            slots={{
                              openPickerIcon: CustomCalendarIcon,
                            }}
                            onBlur={() =>
                              setTouched({ ...touched, plan_date: true })
                            }
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                variant: "filled",
                                InputLabelProps: {
                                  style: { fontSize: 16, fontWeight: 400 },
                                },
                                inputProps: {
                                  style: { height: "20px" },
                                },
                                placeholder: "dd/mm/yyyy",
                                sx: {
                                  input: {
                                    "&::placeholder": {
                                      fontSize: 16,
                                      fontWeight: 400,
                                    },
                                  },
                                  "& .MuiFormLabel-asterisk": {
                                    color: "red",
                                    fontSize: 20,
                                  },
                                },
                                onKeyDown: (e) => e.preventDefault(),
                              },
                            }}
                          />
                          {touched?.plan_date && errors?.plan_date && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.plan_date}`}</FormHelperText>
                          )}
                        </LocalizationProvider>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="Actual Expected Date"
                            disabled={isViewIssueModal}
                            value={
                              values?.actual_expected_date
                                ? dayjs(values.actual_expected_date)
                                : null
                            }
                            format="DD-MM-YYYY"
                            onChange={(newValue) => {
                              handleChange({
                                target: {
                                  name: "actual_expected_date",
                                  value: newValue ? newValue : "",
                                },
                              });
                            }}
                            slots={{
                              openPickerIcon: CustomCalendarIcon,
                            }}
                            onBlur={() =>
                              setTouched({
                                ...touched,
                                actual_expected_date: true,
                              })
                            }
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                variant: "filled",
                                InputLabelProps: {
                                  style: { fontSize: 16, fontWeight: 400 },
                                },
                                inputProps: {
                                  style: { height: "20px" },
                                },
                                placeholder: "dd/mm/yyyy",
                                sx: {
                                  input: {
                                    "&::placeholder": {
                                      fontSize: 16,
                                      fontWeight: 400,
                                    },
                                  },
                                  "& .MuiFormLabel-asterisk": {
                                    color: "red",
                                    fontSize: 20,
                                  },
                                },
                                onKeyDown: (e) => e.preventDefault(),
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="Revised Plan Date"
                            value={
                              values?.revised_plan_date ? dayjs(values.revised_plan_date) : null
                            }
                            format="DD-MM-YYYY"
                            onChange={(newValue) => {
                              handleChange({
                                target: {
                                  name: "revised_plan_date",
                                  value: newValue ? newValue : "",
                                },
                              });
                            }}
                            slots={{
                              openPickerIcon: CustomCalendarIcon,
                            }}
                            onBlur={() =>
                              setTouched({ ...touched, revised_plan_date: true })
                            }
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                variant: "filled",
                                InputLabelProps: {
                                  style: { fontSize: 16, fontWeight: 400 },
                                },
                                inputProps: {
                                  style: { height: "20px" },
                                },
                                placeholder: "dd/mm/yyyy",
                                sx: {
                                  input: {
                                    "&::placeholder": {
                                      fontSize: 16,
                                      fontWeight: 400,
                                    },
                                  },
                                  "& .MuiFormLabel-asterisk": {
                                    color: "red",
                                    fontSize: 20,
                                  },
                                },
                                onKeyDown: (e) => e.preventDefault(),
                              },
                            }}
                          />
                          {touched?.revised_plan_date && errors?.revised_plan_date && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.revised_plan_date}`}</FormHelperText>
                          )}
                        </LocalizationProvider>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Autocomplete
                          options={numbers}
                          getOptionLabel={(option) => option.toString()}
                          value={typeof values?.tat === 'number' ? values.tat : null}
                          onChange={(_, newValue) => setFieldValue('tat', newValue ?? null)}
                          onBlur={() =>
                            setTouched({
                              ...touched,
                              tat: true,
                            })
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="TAT"
                              placeholder="Select TAT"
                              name="tat"
                              variant="filled"
                              slotProps={{ inputLabel: { shrink: true } }}
                            />
                          )}
                          ListboxProps={{ sx: { fontSize: '13px' } }}
                        />
                        {touched?.tat && errors?.tat && (
                          <FormHelperText sx={{ color: '#C52A1A', fontSize: '12px' }}>
                            {errors.tat}
                          </FormHelperText>
                        )}
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Autocomplete
                          options={Statuses}
                          disabled={isViewIssueModal}
                          getOptionLabel={(option) => option?.label}
                          value={
                            Statuses.find(
                              (option) => option.label === values?.status
                            ) || null
                          }
                          onChange={(_, newValue) =>
                            setFieldValue(
                              "status",
                              newValue ? newValue.label : ""
                            )
                          }
                          onBlur={() =>
                            setTouched({ ...touched, status: true })
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Status"
                              name="status"
                              // error={touched?.package && Boolean(errors?.package)}
                              // helperText={touched?.package && errors?.package}
                              slotProps={{ inputLabel: { shrink: true } }}
                              variant="filled"
                            />
                          )}
                          ListboxProps={{
                            sx: { fontSize: "13px" },
                          }}
                        />
                        {touched?.status && errors?.status && (
                          <FormHelperText
                            sx={{ color: "#C52A1A", fontSize: "12px" }}
                          >{`${errors?.status}`}</FormHelperText>
                        )}
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Autocomplete
                          options={escalationRequired}
                          disabled={isViewIssueModal}
                          getOptionLabel={(option) => option?.label}
                          value={
                            escalationRequired.find(
                              (option) =>
                                option.label ===
                                (values?.escalation_required ? "Yes" : "No")
                            ) || null
                          }
                          onChange={(_, newValue) =>
                            setFieldValue(
                              "escalation_required",
                              newValue ? newValue.label : ""
                            )
                          }
                          onBlur={() =>
                            setTouched({
                              ...touched,
                              escalation_required: true,
                            })
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Escalation Required"
                              name="escalation_required"
                              // error={touched?.package && Boolean(errors?.package)}
                              // helperText={touched?.package && errors?.package}
                              slotProps={{ inputLabel: { shrink: true } }}
                              variant="filled"
                            />
                          )}
                          ListboxProps={{
                            sx: { fontSize: "13px" },
                          }}
                        />
                        {touched?.escalation_required &&
                          errors?.escalation_required && (
                            <FormHelperText
                              sx={{ color: "#C52A1A", fontSize: "12px" }}
                            >{`${errors?.escalation_required}`}</FormHelperText>
                          )}
                      </Grid>

                      {/* <Grid item xs={12}>
                        <TextField
                          label="Current Status"
                          name="current_status"
                          fullWidth
                          multiline
                          value={values?.current_status}
                          onChange={handleChange}
                          onBlur={() =>
                            setTouched({ ...touched, current_status: true })
                          }
                          variant="filled"
                          disabled={isViewIssueModal}
                        />
                        {touched?.current_status && errors?.current_status && (
                          <FormHelperText
                            sx={{ color: "#C52A1A", fontSize: "12px" }}
                          >{`${errors?.current_status}`}</FormHelperText>
                        )}
                      </Grid> */}

                      {/* <Grid2 size={12}>
                                                {issueDetail?.data?.files?.length > 0 &&
                                                    <>
                                                        <List dense={dense}>
                                                            {issueDetail?.data?.files?.map((file, index) => (
                                                                <ListItem
                                                                    key={index}
                                                                    sx={{ padding: 0 }}
                                                                    secondaryAction={
                                                                        <IconButton edge="end" aria-label="delete" role="link" onClick={() => handleRemoveFile(index)}>
                                                                            <RxCross2 />
                                                                        </IconButton>
                                                                    }
                                                                >
                                                                    <ListItemAvatar>
                                                                        <Avatar sx={{ background: 'none' }}>
                                                                            <FaRegFileLines fontSize="inherit" style={{ color: '#474747' }} />
                                                                        </Avatar>
                                                                    </ListItemAvatar>
                                                                    <ListItemText
                                                                        primary={
                                                                            <span
                                                                                style={{ cursor: "pointer", color: "#007bff", textDecoration: "underline" }}
                                                                                onClick={() => {
                                                                                    window.open(`${API_END_POINT}${file?.name}`, "_blank");
                                                                                }}
                                                                            >
                                                                                {file?.name}
                                                                            </span>
                                                                        }
                                                                        secondary={secondary ? 'Secondary text' : null}
                                                                    />
                                                                </ListItem>
                                                            ))}
                                                        </List>
                                                    </>
                                                }
                                            </Grid2> */}

                      <Grid item xs={12}>
                        {files.length > 0 && (
                          <>
                            <Typography
                              variant="h6"
                              gutterBottom
                              style={{
                                color: "#474747",
                                fontWeight: "400",
                                fontSize: "16px",
                              }}
                            >
                              Uploaded Files
                            </Typography>

                            <List dense>
                              {files.map((file, index) => (
                                <ListItem
                                  key={index}
                                  sx={{
                                    padding: 0,
                                  }}
                                  secondaryAction={
                                    <IconButton
                                      edge="end"
                                      aria-label="delete"
                                      onClick={() =>
                                        handleRemoveFile(file.name)
                                      }
                                    >
                                      <RxCross2 />
                                    </IconButton>
                                  }
                                >
                                  <ListItemAvatar>
                                    <Avatar sx={{ background: "none" }}>
                                      <FaRegFileLines
                                        fontSize="inherit"
                                        style={{ color: "#474747" }}
                                      />
                                    </Avatar>
                                  </ListItemAvatar>
                                  <ListItemText primary={`${file.name}`} />
                                </ListItem>
                              ))}
                            </List>
                          </>
                        )}
                      </Grid>
                      {!isViewIssueModal && (
                        <Grid item xs={12}>
                          <DragAndDropUpload
                            onDrop={handleDrop}
                            multi={true}
                            fileType="both"
                          />
                        </Grid>
                      )}
                      <Grid item xs={12}>
                        {/* <Button
                          onClick={cancelIssue}
                          variant="outlined"
                          sx={{
                            color: `${newtheme?.customSettings?.themeColor}`,
                            border: `1px solid ${newtheme?.customSettings?.themeColor}`,
                            padding: "6px 20px",
                            fontWeight: "500",
                            textTransform: "none",
                            float: "right",
                            fontSize: "16px",
                            marginBottom: "20px",
                          }}
                        >
                          Cancel
                        </Button> */}
                        {!isViewIssueModal && (
                          <Button
                            type="submit"
                            loading={isLoading}
                            variant="contained"
                            sx={{
                              marginRight: "20px",
                              backgroundColor: `${newtheme?.customSettings?.themeColor}`,
                              color: "#FFF",
                              padding: "6px 20px",
                              fontWeight: "500",
                              textTransform: "none",
                              float: "right",
                              fontSize: "16px",
                            }}
                          >
                            Edit Clearance
                          </Button>
                        )}
                      </Grid>
                    </Grid>
                  </form>
                )}
              </Formik>
            </Box>
          </ThemeProvider>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
